import { useEffect } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { Box, CircularProgress, Typography, Alert, Button } from '@mui/material'
import { useAuthStore } from '../stores/authStore'

export default function SsoCallbackPage() {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()
  const login = useAuthStore((s) => s.login)

  const token = searchParams.get('token')
  const error = searchParams.get('error')

  useEffect(() => {
    if (token) {
      login(token)
      navigate('/apps', { replace: true })
    }
  }, [token, login, navigate])

  if (error) {
    return (
      <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', minHeight: '100vh', gap: 2, px: 2 }}>
        <Alert severity="error" sx={{ maxWidth: 480 }}>
          {t('login.ssoError')}: {error}
        </Alert>
        <Button variant="contained" onClick={() => navigate('/login')}>
          {t('twoFactor.backToLogin')}
        </Button>
      </Box>
    )
  }

  if (token) {
    return (
      <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', minHeight: '100vh', gap: 2 }}>
        <CircularProgress />
        <Typography variant="body2" color="text.secondary">
          {t('login.ssoProcessing')}
        </Typography>
      </Box>
    )
  }

  // No token and no error — redirect to login
  navigate('/login', { replace: true })
  return null
}